import { render } from "./OrderCommentModal.vue?vue&type=template&id=644fb83e&scoped=true"
import script from "./OrderCommentModal.vue?vue&type=script&lang=js"
export * from "./OrderCommentModal.vue?vue&type=script&lang=js"

import "./OrderCommentModal.vue?vue&type=style&index=0&id=644fb83e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fb83e"]])

export default __exports__